<template>
  <div>
    <Onboarding
      v-if="isVisible && currentStepData"
      :key="currentStepIndex"
      :targetSelector="currentStepData?.targetSelector"
      :optionTargetSelector="currentStepData?.optionTargetSelector"
      :message="currentStepData?.message"
      :closeText="currentStepData?.closeText"
      :tooltipPosition="currentStepData?.tooltipPosition"
      :round="currentStepData?.round"
      :offsetX="currentStepData?.offsetX"
      :canOutsideClick="true"
      :highlightPadding="currentStepData?.highlightPadding"
      tooltipPadding="14px 20px"
      tooltipBorderRadius="15px"
      @onboarding-outside-clicked="outsideClicked"
      @onboarding-finished="nextStep"
      @onboarding-close-clicked="closeOnboarding"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Onboarding from "@/components/molecules/OnBoarding.vue";
import { NolaAnalytics, NolaContentType, NolaItemId } from "@/lib/utils/analytics";

interface StepData {
  targetSelector: string;
  optionTargetSelector?: string;
  message: string;
  tooltipPosition: string;
  closeText: string;
  round: boolean;
  offsetX?: number;
  highlightPadding: object;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { Onboarding },
  data() {
    return {
      isVisible: true,
      currentStepIndex: 0,
      nolaAnalytics: new NolaAnalytics(this.$gtm, this.$store),
    };
  },
  computed: {
    steps() {
      return [
        {
          targetSelector: ".tutorial-novel-top",
          optionTargetSelector: ".tutorial-novel-bottom",
          message: `<div class='first-nola-onboarding-step1' style='font-size:var(--font-size-md);margin-bottom:16px;'>${this.$t("firstNolaOnboarding.step1.message")}</div>`,
          tooltipPosition: "right-top",
          highlightPadding: { top: 0, bottom: 0, left: 0, right: 0 },
          closeText: this.$t("firstNolaOnboarding.step1.closeText") as string,
          offsetX: 0,
          round: false,
        },
        {
          targetSelector: ".tutorial-back-home",
          optionTargetSelector: "",
          message: `<div style='font-size:var(--font-size-md);margin-bottom:10px;'>${this.$t("firstNolaOnboarding.step2.message")}</div>`,
          tooltipPosition: "bottom-left",
          highlightPadding: { top: 2, bottom: 4, left: 6, right: 6 },
          closeText: this.$t("firstNolaOnboarding.step2.closeText") as string,
          offsetX: 20,
          round: false,
        },
      ] as StepData[];
    },
    currentStepData() {
      return this.steps[this.currentStepIndex] || null;
    },
  },
  methods: {
    nextStep() {
      if (this.currentStepIndex < this.steps.length - 1) {
        this.currentStepIndex += 1;
        this.nolaAnalytics.logViewItemEvent(NolaItemId.EditorOnboardingBack, NolaContentType.Onboarding);
      } else {
        this.isVisible = false;
        this.$emit("tutorial-completed");
      }
    },
    closeOnboarding() {
      // 次へボタンのクリック
      if (this.currentStepIndex === 0) {
        this.nolaAnalytics.logButtonEvent(NolaItemId.EditorOnboardingNext);
      } else {
        // 閉じるボタンのクリック
        this.nolaAnalytics.logButtonEvent(NolaItemId.EditorOnboardingClose);
      }
    },
    outsideClicked() {
      this.nolaAnalytics.logButtonEvent(NolaItemId.EditorOnboardingOutside);
    },
  },
});

interface Props {}

interface Data {
  isVisible: boolean;
  currentStepIndex: number;
  nolaAnalytics: NolaAnalytics;
}

interface Computed {
  steps: StepData[];
  currentStepData: StepData | null;
}

interface Methods {
  nextStep(): void;
  closeOnboarding(): void;
  outsideClicked(): void;
}
</script>
